import { Suspense, lazy } from 'react'
import type { Kartenpunkt } from './Karte'

/**
 * Die Karte, nachgeladen.
 *
 * <p>Leaflet und seine Stilvorlage wiegen zusammen rund zweihundert Kilobyte. Fest
 * eingebunden zahlte die jeder, der die Anwendung öffnet — auch wer nur den Dienstplan
 * ansieht und nie eine Karte aufruft. Als eigener Brocken kommt sie erst, wenn eine
 * Fahrzeugakte oder ein Unfallbericht sie braucht.
 *
 * <p>Die Wartezeit steht als Fläche in der Größe der späteren Karte da, nicht als
 * Ladekringel: So springt das Layout nicht, wenn sie eintrifft.
 */
const Geladen = lazy(() => import('./Karte'))

interface Eigenschaften {
  punkte: Kartenpunkt[]
  /** Eine Fahrtspur statt einzelner Punkte — siehe Karte. */
  spur?: Kartenpunkt[]
  klein?: boolean
  hoehe?: number | string
  beimKlicken?: () => void
  zoom?: number
  /** Macht die Spur-Punkte anklickbar; Index in der Spur. */
  beimPunktKlick?: (index: number) => void
  /** Ausschnitt an die Punkte anpassen (beim stillen Nachladen aus). */
  einpassen?: boolean
}

export function Karte(eigenschaften: Eigenschaften) {
  const hoehe = eigenschaften.hoehe ?? (eigenschaften.klein ? 160 : '100%')
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: hoehe,
            width: '100%',
            borderRadius: eigenschaften.klein ? 8 : 0,
            background: 'var(--grau-100)',
            border: eigenschaften.klein ? '1px solid var(--grau-200)' : undefined,
            display: 'grid',
            placeItems: 'center',
            color: 'var(--grau-500)',
            fontSize: '0.8rem',
          }}
        >
          Karte wird geladen …
        </div>
      }
    >
      <Geladen {...eigenschaften} />
    </Suspense>
  )
}

export type { Kartenpunkt }
